import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import RoofRejuvenation from "@/components/site/RoofRejuvenation";
import SignatureProject from "@/components/site/SignatureProject";
import FeaturedWork from "@/components/site/FeaturedWork";
import Process from "@/components/site/Process";
import GreenBuilding from "@/components/site/GreenBuilding";
import RoofingFAQ from "@/components/site/RoofingFAQ";
import About from "@/components/site/About";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <RoofRejuvenation />
      <SignatureProject />
      <FeaturedWork />
      <Process />
      <GreenBuilding />
      <About />
      <Reviews />
      <RoofingFAQ />
      <Contact />
      <Footer />
    </main>
  );
}
